import React from 'react'
import TopSec from '../../Component/Investment/Topsec'
import TopInvestment from '../../Component/Investment/TopInvestment'
import Trust from '../../Component/Investment/Trust'
import Seo from '../../Component/Seo'

function Investment() {
  return (
    <div>
      <Seo
        title='Halal Investment Platform for Ethical Returns | Halal Wealth'
        description='Explore Shariah-compliant investment opportunities with Halal Wealth. Grow your money ethically through transparent, interest-free investment pods.'
        pathname='/investment'
      />
      <TopSec/>
      <TopInvestment/>
      <Trust/>

    </div>
  )
}

export default Investment
